/* eslint-disable import/no-internal-modules */
import { SecureRoute } from '@okta/okta-react';
import React from 'react';
import { Redirect, Switch, useParams } from 'react-router';
import { HubspotConfig } from 'api/integrations/hubspot';
import { PageLoading } from 'components/atoms/loading';
import { NotFound } from 'components/atoms/result';
import {
  HubspotSettings,
  HubspotResourceMappings,
} from 'components/organisms/module-settings/integrations/integrations-list';
import { IntegrationStatusTypes } from 'components/organisms/module-settings/integrations/integrations-list/authentication-types';
import { RoutePaths } from 'constant';
import {
  useHubspotConfigByIdQuery,
  useHubspotConfigQuery,
} from 'queries/hubspot-integration';

export const getConfiG = (data?: HubspotConfig[]) => data?.[0];

const AutomaticRedirection = () => {
  const { data, status } = useHubspotConfigQuery();

  switch (status) {
    case 'loading': {
      return <PageLoading />;
    }
    case 'success': {
      const config = getConfiG(data);

      if (config) {
        if (config.integrationStatus === IntegrationStatusTypes.Expired) {
          return (
            <Redirect
              push
              to={`${RoutePaths.hubspotIntegration}/${config.integrationId}/settings`}
            />
          );
        }

        return (
          <Redirect
            push
            to={`${RoutePaths.hubspotIntegration}/${config.integrationId}/resource-mappings`}
          />
        );
      }

      return (
        <Redirect push to={`${RoutePaths.hubspotIntegration}/new/settings`} />
      );
    }
    case 'error': {
      return <Redirect push to={RoutePaths.hubspotIntegration} />;
    }
    default: {
      return null;
    }
  }
};

const HubspotIntegrationsByIdPage = () => {
  const { integrationId } = useParams<{ integrationId: string }>();
  const { isError, data, isLoading } = useHubspotConfigByIdQuery(
    Number(integrationId),
    { enabled: integrationId !== 'new' },
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <AutomaticRedirection />;
  }

  return (
    <Switch>
      <SecureRoute path={RoutePaths.hubspotResourceMappings}>
        <HubspotResourceMappings />
      </SecureRoute>

      <SecureRoute path={RoutePaths.hubspotSettings}>
        <HubspotSettings data={data} />
      </SecureRoute>

      <SecureRoute path="*">
        <NotFound />
      </SecureRoute>
    </Switch>
  );
};

export const HubspotIntegrationsLandingPage = () => {
  return (
    <Switch>
      <SecureRoute path={RoutePaths.hubspotIntegrationById}>
        <HubspotIntegrationsByIdPage />
      </SecureRoute>

      <SecureRoute path={RoutePaths.hubspotIntegration}>
        <AutomaticRedirection />
      </SecureRoute>

      <SecureRoute path="*">
        <NotFound />
      </SecureRoute>
    </Switch>
  );
};
